import { RetailerDeliveryLocationModel } from '../../../../app/services/api/ofdClient';

export const editDeliveryLocation = (
  locations: RetailerDeliveryLocationModel[],
  locationToEdit: RetailerDeliveryLocationModel,
): RetailerDeliveryLocationModel[] => {
  const existingIndex = locations.findIndex((loc) => loc.id === locationToEdit.id);

  if (existingIndex !== -1) {
    const updated = [...locations];
    updated[existingIndex] = { ...locationToEdit };
    return updated;
  } else {
    const minId = locations.reduce(
      (min, loc) => (loc.id && loc.id < min ? loc.id : min),
      0,
    );
    const newId = minId - 1;

    return [...locations, { ...locationToEdit, id: newId }];
  }
};

export const deleteDeliveryLocation = (
  locations: RetailerDeliveryLocationModel[],
  idToDelete: number,
): RetailerDeliveryLocationModel[] => {
  return locations.filter((loc) => loc.id !== idToDelete);
};
